export default __webpack_public_path__ + "static/NeedsSection_es-563d78562db935867b2abf4c73894817.png";